var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import classNames from "classnames";
import React from "react";
export const QuiSpinner = (_a) => {
    var { size, color, className } = _a, otherProps = __rest(_a, ["size", "color", "className"]);
    const spinnerClassName = classNames(`qui-spinner`, `qui-spinner-${size}`, className, {
        [`qui-color-${color}`]: !!color,
    });
    return (React.createElement("div", Object.assign({ className: spinnerClassName }, otherProps),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null),
        React.createElement("div", null)));
};
